import { ATDLNLogicOperator } from "../../data-atdl/enums/atdl-logic-operator.enum";

export class ICDValidationOutcomeModel {
  public icdId: string;
  public refName: string;
  public errorMsg: string;
  public valid: boolean;

  constructor(icdId?: string, refName?: string, valid?: boolean, errorMsg?: string) {
    this.icdId = icdId != null ? icdId : null;
    this.refName = refName != null ? refName : null;
    this.valid = valid != null ? valid : null;
    this.errorMsg = errorMsg != null ? errorMsg : null;
  }
}
